import collectionService from './CollectionService'

export default collectionService
